module.exports = __webpack_public_path__ + "img/REFRESH_STATUS.8f789db9.svg";